// Google Font Icon https://fonts.google.com/icons?selected=Material+Symbols+Outlined:construction:FILL@0;wght@400;GRAD@0;opsz@24&icon.query=construc&icon.size=24&icon.color=%23e3e3e3

import { createSvgIcon } from '@material-ui/core';

export const ConstructionIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M756-120 537-339l84-84 219 219-84 84Zm-552 0-84-84 276-276-68-68-28 28-51-51v82l-28 28-121-121 28-28h82l-50-50 142-142q20-20 43-29t47-9q24 0 47 9t43 29l-92 92 50 50-28 28 68 68 90-90q-4-11-6.5-23t-2.5-24q0-59 40.5-99.5T701-841q15 0 28.5 3t27.5 9l-99 99 72 72 99-99q7 14 9.5 27.5T841-701q0 59-40.5 99.5T701-561q-12 0-24-2t-23-7L204-120Z" />
  </svg>,
  'ConstructionIcon',
);
